const facts = [
  { label: 'Business Type', value: 'Full-service carpet & flooring company' },
  { label: 'Location', value: '1943 Main St E, Snellville, GA 30078' },
  { label: 'Phone', value: '770.236.1255' },
  { label: 'Service Area', value: 'Metro Atlanta & surrounding counties' },
  { label: 'Guarantee', value: '100% satisfaction — re-service free if needed' },
  { label: 'Financing', value: 'Available for qualifying projects' },
];

const services = [
  'Carpet Cleaning & Repair',
  'Luxury Vinyl Plank (LVP) Installation',
  'Hardwood Floor Services',
  'Tile & Grout Cleaning',
  'Pet Odor & Stain Removal',
  'Upholstery Cleaning',
  'Laminate & Engineered Wood',
  'Air Duct Cleaning',
];

export default function AIAnswerBlock() {
  return (
    <section className="py-28 bg-stone-50" aria-label="About Carpet & Flooring Transformers">
      <div className="max-w-7xl mx-auto px-6">

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">

          {/* Left column */}
          <div>
            <p className="text-amber-600 text-[11px] font-bold tracking-[0.25em] uppercase mb-4">Quick Reference</p>
            <h2 className="font-serif text-4xl md:text-5xl text-stone-900 mb-6 leading-tight">
              About Carpet &amp;<br />Flooring Transformers
            </h2>
            <p className="text-stone-600 text-lg leading-relaxed mb-10">
              A family-owned, full-service flooring company based in Snellville, GA. We specialize in carpet cleaning, repair, and installation — plus hard surface flooring — for homeowners and businesses across the Greater Metro Atlanta area.
            </p>

            {/* Fact table */}
            <div className="border border-stone-200 rounded-xl overflow-hidden mb-10">
              {facts.map((f, i) => (
                <div
                  key={f.label}
                  className={`flex items-start gap-4 px-6 py-4 ${i % 2 === 0 ? 'bg-white' : 'bg-stone-50'}`}
                >
                  <span className="text-stone-400 text-sm w-36 flex-shrink-0 font-medium">{f.label}</span>
                  <span className="text-stone-800 text-sm font-semibold">{f.value}</span>
                </div>
              ))}
            </div>

            {/* Services list */}
            <div>
              <p className="text-stone-700 font-bold text-sm uppercase tracking-widest mb-4">Services Offered</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                {services.map((s) => (
                  <div key={s} className="flex items-center gap-2.5 text-sm text-stone-600">
                    <div className="w-4 h-4 flex items-center justify-center text-amber-500 flex-shrink-0">
                      <i className="ri-arrow-right-s-fill text-base"></i>
                    </div>
                    {s}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right column */}
          <div className="flex flex-col gap-6">
            {/* Image */}
            <div className="relative rounded-2xl overflow-hidden w-full h-[380px]">
              <img
                src="https://www.carpettransformers.com/wp-content/uploads/2019/04/carpet-pros.jpg"
                alt="Certified carpet cleaning technician — Carpet & Flooring Transformers Snellville GA"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <p className="text-white font-bold text-lg leading-snug">Certified Flooring Professionals</p>
                <p className="text-white/70 text-sm mt-1">Snellville, GA — Serving Metro Atlanta</p>
              </div>
            </div>

            {/* Contact card */}
            <div className="bg-stone-900 rounded-2xl p-7 flex flex-col gap-5">
              <div>
                <p className="text-stone-400 text-[11px] font-bold tracking-[0.2em] uppercase mb-1">Store Address</p>
                <p className="text-white font-semibold text-base">1943 Main St E, Snellville, GA 30078</p>
              </div>
              <div className="w-full h-px bg-stone-700"></div>
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-stone-400 text-[11px] font-bold tracking-[0.2em] uppercase mb-1">Call Us</p>
                  <a href="tel:7702361255" className="text-amber-400 font-bold text-2xl hover:text-amber-300 transition-colors cursor-pointer">
                    770.236.1255
                  </a>
                </div>
                <a
                  href="tel:7702361255"
                  className="w-12 h-12 flex items-center justify-center bg-amber-600 hover:bg-amber-500 rounded-full text-white transition-colors cursor-pointer"
                >
                  <i className="ri-phone-fill text-xl"></i>
                </a>
              </div>
            </div>

            {/* Brand logos */}
            <div className="bg-white border border-stone-100 rounded-2xl p-6">
              <p className="text-stone-400 text-[11px] font-bold tracking-[0.2em] uppercase mb-4">Brands We Carry</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { name: 'Mohawk', img: 'https://www.carpettransformers.com/wp-content/uploads/2024/09/mohawk.png' },
                  { name: 'Shaw Flooring', img: 'https://www.carpettransformers.com/wp-content/uploads/2024/09/shaw-flooring.png' },
                  { name: 'MSI', img: 'https://www.carpettransformers.com/wp-content/uploads/2024/09/msi.png' },
                  { name: 'Dreamweaver', img: 'https://www.carpettransformers.com/wp-content/uploads/2024/09/dreamweaver-logo.png' },
                ].map((brand) => (
                  <div key={brand.name} className="flex items-center justify-center bg-stone-50 rounded-lg p-3 h-14">
                    <img
                      src={brand.img}
                      alt={brand.name}
                      className="h-8 w-auto object-contain"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
